import { userApi } from './index';
import { config } from '../config';
import { IPaymentCards } from '../../../models/PaymentCard';

export const paymentsCardsApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    getListOfCards: build.query<IPaymentCards, string>({
      query: () => ({
        url: config.PAYMENTS_CARDS.LIST_OF_CARDS,
      }),
      providesTags: () => ['CardList'],
    }),
    deleteCard: build.mutation<{ success: string }, string>({
      query: (cardId) => ({
        method: 'DELETE',
        url: config.PAYMENTS_CARDS.DELETE_CARD(cardId),
      }),
      invalidatesTags: ['RegularPayment', 'CardList'],
    }),
  }),
});
